import React, { useEffect } from "react";
import withRouter from "../../components/Common/withRouter";
import { useDispatch } from "react-redux";
import { setUser } from "src/store/auth/authSlice";

interface LogoutProps {
  history: any;
}

const Logout = ({ history }: LogoutProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setUser(undefined));

    window.location.replace("/login");
  }, [dispatch, history]);

  return <React.Fragment></React.Fragment>;
};

export default withRouter(Logout);
